import React from 'react';
import PropTypes from 'prop-types';

const RowFooter = ({ labelFooter, children }) => (
  <div className="flex-row style-row-border-top padding-top-20">
    <div className="flex-grid-first"> {labelFooter} </div>
    {children}
  </div>
);

RowFooter.propTypes = {
  labelFooter: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  children: PropTypes.any.isRequired,
};

RowFooter.defaultProps = {
  labelFooter: '',
};

export default RowFooter;
